module.exports = __webpack_public_path__ + "static/media/e-citizen_logo_ecitizen_white.ea54108c.png";